<template>
  <div class="widgets">
    <draggable
      v-model="definition"
      :options="{
        group: { name: 'widgets', pull: true, put: true },
        handle: '.drag-handle'
      }"
      element="div"
      class="cards"
      style="min-height: 1vh"
      @change="updateLayout(definition)"
    >
      <div v-for="(component, index) of definition" :key="component.id">
        <component :is="component.type" :key="component.id" :title="component.name" style="height: 100%;">
          <template #widget-options>
            <widget-options
              :component="component"
              :options="options"
              :target-index="index"
              :allow-resize="false"
              :allow-delete="false"
              :active="!!component.type"
              @select-option="changeBoxContent"
            />
          </template>
        </component>
      </div>
    </draggable>
  </div>
</template>

<script>
import * as apiTo from '@api/api-routes'
import { cloneDeep } from 'lodash'
// Components
import draggable from 'vuedraggable'
import WidgetOptions from '@/components/widgets/WidgetOptions'

const mapTypes = {
  'value-per-department': 'value-per-department-over-time',
  'share-per-department': 'share-per-department',
  'budget-vs-actual-v1': 'budget-vs-actual-per-department-version-1',
  'budget-vs-actual-v2': 'budget-vs-actual-per-department-version-2',
  'share-per-product-type': 'share-per-product-type',
  'share-per-subject-category': 'share-per-subject-category',
  'share-per-publisher': 'share-per-publisher',
  'share-per-vendor': 'share-per-vendor'
}

export default {
  components: {
    draggable,
    WidgetOptions,
    ValuePerDepartment: () => import('./charts/value-per-department/ValuePerDepartment'),
    SharePerDepartment: () => import('./charts/share-per-department/SharePerDepartment'),
    BudgetVsActualV1: () => import('./charts/budget-vs-actual-v1/BudgetVsActualV1'),
    BudgetVsActualV2: () => import('./charts/budget-vs-actual-v2/BudgetVsActualV2'),
    SharePerProductType: () => import('./charts/SharePerProductType'),
    SharePerSubjectCategory: () => import('./charts/SharePerSubjectCategory'),
    SharePerPublisher: () => import('./charts/SharePerPublisher'),
    SharePerVendor: () => import('./charts/SharePerVendor')
  },

  props: {
    initialDefinition: {
      type: Array,
      required: true
    },
    availableElements: {
      type: Array,
      required: true
    },
    defaultWidgets: {
      type: Array,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    context: {
      type: Object,
      required: true
    },
    setContext: {
      type: Function,
      required: true
    }
  },

  data: () => ({
    definition: []
  }),

  watch: {
    initialDefinition: {
      handler: 'updateDefinition',
      immediate: true
    }
  },

  methods: {
    updateDefinition(definition) {
      this.definition = definition.length ? definition : this.defaultWidgets
    },

    changeBoxContent({ value, index }) {
      const name = this.availableElements.find(el => el.slug === mapTypes[value]).name
      let cards = cloneDeep(this.definition)
      cards[index].type = value
      cards[index].name = name
      this.updateLayout(cards)
    },

    updateLayout(definition) {
      apiTo.updateLayout(this.context.id, { definition }).then(({ data }) => this.setContext(data.result.definition))
    }
  }
}
</script>

<style lang="stylus" scoped>
.cards {
  display grid
  grid-template-columns repeat(3, 1fr)
  justify-content center
  gap 15px
}
</style>
